import React from 'react';

import {
    withStyles,
    ListItem,
    Grid,
    ListItemText,
    Typography,
    Button,
    ButtonBase,
    Snackbar,
    Divider,
} from '@material-ui/core';

import AppData from '../../model/AppData';
import MSnackbar from '../view/MSnackbar';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import Cancel from '@material-ui/icons/Cancel'
import Apis from '../../network/Apis';

class AnchorDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nickname: '',
            hobby: '',
            phonenumber: '',
            union: '',
            snackopened: false,
            content: '',
            message: '',
        };
        this._saveInfo = this._saveInfo.bind(this);
        this._getModifyInfoBack = this._getModifyInfoBack.bind(this);
        this._onCancel = this._onCancel.bind(this);
    }

    _saveInfo() {
        const { nickname, hobby, union, phonenumber, content } = this.state;
        if (!nickname || nickname === '') {
            this.setState({ message: '昵称不能为空', snackopened: true });
            return;
        }

        if (!hobby || hobby === '') {
            this.setState({ message: '请输入兴趣爱好', snackopened: true });
            return;
        }

        if (!phonenumber || phonenumber === '') {
            this.setState({ message: '请输入联系方式', snackopened: true });
            return;
        }

        if (!content || content === '') {
            this.setState({ message: '请输入自我介绍', snackopened: true });
            return;
        }

        this._onCommit();
    }

    _onCommit = async () => {
        let result = await Apis.encryptionHostReal(this.state.nickname, this.state.hobby, this.state.union, this.state.phonenumber, this.state.content);
        console.log('_onCommit', result);
        if (result.code == 200) {
            this.setState({ message: '提交成功~', snackopened: true });
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    _getModifyInfoBack(result) {
        if (result.RetCode === 0) {
            this.setState({ message: '信息修改成功', snackopened: true });
            this.timeout = setTimeout(() => {
                window.history.back();
            }, 2000);
        } else {
            this.setState({ message: '修改失败', snackopened: true });
        }
    }

    _onCancel(index) {
        console.log("ccececececcecce", index)
        switch (index) {
            case 0:
                this.setState({ nickname: '' });
                break;
            case 1:
                this.setState({ hobby: '' });
                break;
            case 2:
                this.setState({ union: '' });
                break;
            case 3:
                this.setState({ phonenumber: '' });
                break;

            default:
                break;
        }

    }

    // 个人信息
    render() {
        const { classes } = this.props;
        const { nickname, hobby, union, phonenumber, content, snackopened, message } = this.state;
        let isSubmit = nickname.length > 0 && hobby.length > 0 && phonenumber.length > 0 && union.length > 0 && content.length > 0;
        return (
            <MBack title="主播认证">
                <Grid style={{ height: 16 }}></Grid>
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 12, marginLeft: 16, marginRight: 16 }}>您还不是主播哦，请输入一下资料，申请成为主播，我们将会尽 快与您联系！</Typography>} />
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45, marginTop: 16 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13, width: 70 }}>联系名称</Typography>} />
                    <input
                        onChange={event => this.setState({ nickname: event.target.value })}
                        value={nickname}
                        type='text'
                        className={classes.textfield}
                        placeholder='怎么称呼您,提交后不可修改'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel(0)}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13, width: 70 }}>特长爱好</Typography>} />
                    <input
                        onChange={event => this.setState({ hobby: event.target.value })}
                        value={hobby}
                        type='text'
                        className={classes.textfield}
                        placeholder='例如唱歌跳舞、足球篮球、能说会道...'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel(1)}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, width: 70 }}>签约公会</Typography>} />
                    <input
                        onChange={event => this.setState({ union: event.target.value })}
                        value={union}
                        type='text'
                        className={classes.textfield}
                        placeholder='输入您签约的公会,没有可不填'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel(2)}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13, width: 70 }}>联系方式</Typography>} />
                    <input
                        onChange={event => this.setState({ phonenumber: event.target.value })}
                        value={phonenumber}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入您的手机号码、QQ或邮箱'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel(3)}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <Grid style={{ height: 16 }}></Grid>
                <Grid container justify='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '94%', justifyContent: 'center' }} />
                    <textarea
                        onChange={event => this.setState({ content: event.target.value })}
                        value={content}
                        className={classes.textfieldinfo}
                        placeholder="简单的介绍下自己吧,如果您在其他平台直播,可以叫我们去围观哦~" />
                    <Divider light style={{ background: '#E2E2E2', width: '94%', justifyContent: 'center' }} />
                </Grid>

                <Grid style={{ height: 16 }}></Grid>
                <Grid container justify='center' >
                    <ButtonBase
                        className={classes.commitBtn}
                        style={{ color: isSubmit ? '#FFF' : '#66A6F9' }}
                        onClick={this._saveInfo}
                    >提 交</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withStyles((theme) => ({
    commitBtn: {
        backgroundColor: '#187AF9',
        borderRadius: 22.5,
        color: '#66A6F9',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 13,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 13,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '80%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
    textfieldinfo: {
        fontSize: 15,
        height: 99,
        borderRadius: 5,
        width: '90%',
        border: 'none',
        outline: 'none',
    },

}))(AnchorDialog);